<template>
  <section class="premium-welcome-section">
    <div class="welcome-container">
      <div class="welcome-grid">
        <div class="welcome-text-content" data-aos="fade-right">
          <h2 class="section-title">
            {{ $t('home-page.bod.welcome-text') }}
          </h2>
          <p class="welcome-intro">
            {{ $t('home-page.bod.introduction') }}
          </p>
          <div class="info-boxes">
            <div class="info-box" data-aos="fade-up" data-aos-delay="100">
              <div class="info-box-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm11.378-3.917c-.89-1.423-2.567-1.423-3.456 0l-5.25 8.381c-.89 1.423.201 3.267 1.728 3.267h10.5c1.527 0 2.618-1.844 1.728-3.267l-5.25-8.381z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="info-box-text">
                <h3>{{ $t('home-page.bod.brief-desc.content[0].question') }}</h3>
                <p>{{ $t('home-page.bod.brief-desc.content[0].answer') }}</p>
              </div>
            </div>
            <div class="info-box" data-aos="fade-up" data-aos-delay="200">
              <div class="info-box-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 015.69 3.117.75.75 0 01-.88.99A4.982 4.982 0 0012 15a4.982 4.982 0 00-4.81.107.75.75 0 01-.88-.99z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="info-box-text">
                <h3>{{ $t('home-page.bod.brief-desc.content[1].question') }}</h3>
                <p>{{ $t('home-page.bod.brief-desc.content[1].answer') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="welcome-image-wrapper" data-aos="fade-left" data-aos-delay="200">
          <div class="image-overlay"></div>
          <img src="@/assets/truck.jpg" alt="Logistics and transportation" class="welcome-image">
          <div class="image-badge">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="badge-icon">
              <path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
            </svg>
            <span>Certified Excellence</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.premium-welcome-section {
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  overflow: hidden;
}

.premium-welcome-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(10, 45, 97, 0.03) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(217, 119, 6, 0.03) 0%, transparent 50%);
  pointer-events: none;
}

.welcome-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.welcome-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: center;
}

.section-title {
  font-size: 2.75rem;
  font-weight: 700;
  color: #0A2D61;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  text-align: left;
  background: linear-gradient(135deg, #0A2D61 0%, #1e40af 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.welcome-intro {
  font-size: 1.125rem;
  line-height: 1.8;
  color: #475569;
  margin-bottom: 3rem;
  font-weight: 400;
}

.info-boxes {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.info-box {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: all 0.3s ease;
  border: 1px solid rgba(10, 45, 97, 0.08);
}

.info-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-color: rgba(10, 45, 97, 0.15);
}

.info-box-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0A2D61 0%, #1e40af 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(10, 45, 97, 0.2);
  transition: transform 0.3s ease;
}

.info-box:hover .info-box-icon {
  transform: scale(1.1) rotate(5deg);
}

.info-box-icon svg {
  width: 28px;
  height: 28px;
  color: white;
}

.info-box-text h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
}

.info-box-text p {
  margin: 0;
  color: #64748b;
  line-height: 1.7;
  font-size: 1rem;
}

.welcome-image-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  transition: transform 0.5s ease;
}

.welcome-image-wrapper:hover {
  transform: scale(1.02);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(10, 45, 97, 0.1) 0%, rgba(217, 119, 6, 0.1) 100%);
  z-index: 1;
  pointer-events: none;
}

.welcome-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.welcome-image-wrapper:hover .welcome-image {
  transform: scale(1.05);
}

.image-badge {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 1rem 1.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 2;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.badge-icon {
  width: 24px;
  height: 24px;
  color: #d97706;
}

.image-badge span {
  font-weight: 600;
  color: #0A2D61;
  font-size: 0.95rem;
}

@media (max-width: 992px) {
  .premium-welcome-section {
    padding: 4rem 1.5rem;
  }

  .welcome-grid {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .welcome-image-wrapper {
    order: -1;
  }

  .section-title {
    font-size: 2rem;
  }

  .info-box {
    padding: 1.5rem;
  }

  .image-badge {
    bottom: 1rem;
    right: 1rem;
    padding: 0.75rem 1rem;
  }
}

@media (max-width: 640px) {
  .section-title {
    font-size: 1.75rem;
  }

  .welcome-intro {
    font-size: 1rem;
  }

  .info-box {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>
